import { render, staticRenderFns } from "./QueryNewReview.vue?vue&type=template&id=debc40ec&scoped=true&"
import script from "./QueryNewReview.vue?vue&type=script&lang=js&"
export * from "./QueryNewReview.vue?vue&type=script&lang=js&"
import style0 from "./QueryNewReview.vue?vue&type=style&index=0&id=debc40ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debc40ec",
  null
  
)

export default component.exports